import axios from "axios";
import Url from "./BackendURL";

export const getProjects = () => {
    return axios.get(`${Url}projects`, {
        headers: {
            "Content-Type": "application/json",
        }
    })
}

export const postSmartSearch = (query) => {
    return axios.post(`${Url}ask-question`, query, {
        headers: {
            "Content-Type": "application/json",
        }
    })
}

export const postUpload = (data) => {
    return axios.post(`${Url}upload`, data, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    })
}